import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { VirtualClassPage } from './virtual-class.page';

const routes: Routes = [
  {
    path: '',
    component: VirtualClassPage,
    children: [
      {
        path: '',
        loadChildren: () =>
          import(
            './children/virtual-class-home/virtual-class-home.module'
          ).then((m) => m.VirtualClassHomePageModule),
      },
      {
        path: ':incription_id',
        loadChildren: () =>
          import(
            './children/virtual-class-path/virtual-class-path.module'
          ).then((m) => m.VirtualClassPathPageModule),
      },
      {
        path: 'module/:incription_id/:module_id',
        loadChildren: () =>
          import('./children/module-show/module-show.module').then(
            (m) => m.ModuleShowPageModule
          ),
      },
      {
        path: 'class/:incription_id/:class_id',
        loadChildren: () =>
          import('./children/class-show/class-show.module').then(
            (m) => m.ClassShowPageModule
          ),
      },
      {
        path: 'test/:incription_id/:test_id',
        loadChildren: () =>
          import('./children/test-show/test-show.module').then(
            (m) => m.TestShowPageModule
          ),
      },
      {
        path: 'plan/status-account',
        loadChildren: () =>
          import('./children/status-account/status-account.module').then(
            (m) => m.StatusAccountPageModule
          ),
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: '',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VirtualClassPageRoutingModule {}
